import { customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { M8UserFullInfo } from 'services/production/types';

export const getOnlyPromoUsers = async (): Promise<M8UserFullInfo[]> => {
  const fetchURL = getM8AdminURL('getOnlyPromoUsers');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
